var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SectionLoader',{attrs:{"is-loading":_vm.projectUrl.length == 0}},[_c('iframe',{attrs:{"width":"100%","height":_vm.height,"src":_vm.projectUrl,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }